import React, { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { LayoutDashboard, Store, Layers, Activity, Settings, Users, ChevronLeft, ChevronRight, Contact, Pill, ClipboardList, History, PackageSearch } from 'lucide-react';
import { cn } from '../../utils/cn';
const NAV_ITEMS = [{
  label: 'Dashboard',
  href: '/',
  icon: LayoutDashboard
}, {
  label: 'Dawaee Refills',
  href: '/refills',
  icon: Pill,
  badge: 5
}, {
  label: 'Pharmacy Referrals',
  href: '/referrals',
  icon: ClipboardList
}, {
  label: 'Refills History',
  href: '/history/refills',
  icon: History
}, {
  label: 'Referrals History',
  href: '/history/referrals',
  icon: ClipboardList
}, {
  label: 'Inventory',
  href: '/inventory',
  icon: PackageSearch
}, {
  label: 'Customers',
  href: '/customers',
  icon: Contact
}, {
  label: 'Pharmacies',
  href: '/branches',
  icon: Store
}, {
  label: 'Reports',
  href: '/reports',
  icon: Layers
}, {
  label: 'Users',
  href: '/users',
  icon: Users
}, {
  label: 'Settings',
  href: '/settings',
  icon: Settings
}];
interface SidebarProps {
  isOpen: boolean;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}
export function Sidebar({
  isOpen,
  isCollapsed,
  onToggleCollapse
}: SidebarProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useAuthStore(state => state.user);
  return <aside className={cn('bg-slate-900 text-slate-300 flex flex-col h-screen fixed left-0 top-0 border-r border-slate-800 z-50 transition-all duration-300 ease-in-out', isOpen ? 'translate-x-0' : '-translate-x-full', isCollapsed ? 'w-20' : 'w-64')} data-id="element-163">
      <div className={cn('h-20 flex items-center border-b border-slate-800 transition-all duration-300', isCollapsed ? 'justify-center px-0' : 'px-6 justify-between')} data-id="element-164">
        <div className="flex items-center gap-2 font-bold text-white text-lg overflow-hidden whitespace-nowrap" data-id="element-165">
          {isCollapsed ? <div className="flex flex-col gap-1 items-center justify-center flex-shrink-0 bg-white rounded-lg p-1 w-12 h-16" data-id="element-166">
              <img src="https://www.tawuniya.com/assets/tawuniya-logo-BFmobvJd.svg" alt="Tawuniya" className="w-full h-6 object-contain" data-id="element-167" />
              <div className="w-full h-px bg-slate-100" data-id="element-168" />
              <img src="https://cdn.magicpatterns.com/uploads/vTCY5UH2YGZJtqWG4nFSrJ/Screenshot_52.png" alt="Innova" className="w-full h-6 object-contain" data-id="element-169" />
            </div> : <div className="flex items-center gap-3 bg-white rounded-lg px-3 py-2" data-id="element-170">
              <img src="https://www.tawuniya.com/assets/tawuniya-logo-BFmobvJd.svg" alt="Tawuniya Logo" className="h-5 w-auto object-contain" data-id="element-171" />
              <div className="w-px h-5 bg-slate-200" data-id="element-172" />
              <img src="https://cdn.magicpatterns.com/uploads/vTCY5UH2YGZJtqWG4nFSrJ/Screenshot_52.png" alt="Innova Logo" className="h-5 w-auto object-contain" data-id="element-173" />
            </div>}
        </div>
        {!isCollapsed && <button onClick={onToggleCollapse} className="p-1 rounded-md hover:bg-slate-800 text-slate-400 hover:text-white transition-colors" data-id="element-174">
            <ChevronLeft className="w-4 h-4" data-id="element-175" />
          </button>}
      </div>

      <nav className="flex-1 overflow-y-auto overflow-x-hidden py-4 px-3 space-y-1" data-id="element-176">
        {NAV_ITEMS.map(item => <NavLink key={item.href} to={item.href} className={({
        isActive
      }) => cn('flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors', isActive ? 'bg-primary-600 text-white' : 'hover:bg-slate-800 hover:text-white', isCollapsed && 'justify-center px-2')} title={isCollapsed ? item.label : undefined} data-id="element-177">
            <div className="relative" data-id="element-178">
              <item.icon className="w-5 h-5" data-id="element-179" />
              {item.badge && <span className="absolute -top-1.5 -right-1.5 min-w-[16px] h-4 flex items-center justify-center bg-red-500 text-white text-[10px] font-bold rounded-full px-1 border-2 border-slate-900" data-id="element-180">
                  {item.badge}
                </span>}
            </div>
            {!isCollapsed && <span data-id="element-181">{item.label}</span>}
          </NavLink>)}
      </nav>

      <div className={cn('p-4 border-t border-slate-800', isCollapsed && 'flex justify-center')} data-id="element-182">
        {isCollapsed ? <button onClick={onToggleCollapse} className="p-2 rounded-md hover:bg-slate-800 text-slate-400 hover:text-white transition-colors" data-id="element-183">
            <ChevronRight className="w-5 h-5" data-id="element-184" />
          </button> : <button onClick={() => navigate('/settings')} className="w-full flex items-center gap-3 hover:bg-slate-800 p-2 rounded-md transition-colors" data-id="element-185">
            <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center text-xs font-bold text-white" data-id="element-186">
              {user?.name?.split(' ').map(n => n[0]).join('') || 'AD'}
            </div>
            <div className="flex-1 min-w-0 text-left" data-id="element-187">
              <p className="text-sm font-medium text-white truncate" data-id="element-188">
                {user?.name || 'Admin User'}
              </p>
              <p className="text-xs text-slate-500 truncate" data-id="element-189">
                {user?.email || 'admin@waseel.com'}
              </p>
            </div>
          </button>}
      </div>
    </aside>;
}